import Axios, { AxiosResponse } from 'axios';
import { isNullOrUndefined } from 'util';
import { applyReducer, compare } from 'fast-json-patch';
export abstract class BaseService {
  /**
   *
   */
  private _refPath: string[];
  protected readonly _path: string;
  constructor(path?: string) {
    this._path = path;
  }

  protected onUploadProgress = (progressEvent: any, target) => {
    target.percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
  }
  async get<TViewModel, TParam>(path?: string, params?: TParam): Promise<TViewModel> {
    const parseParam = params ? await this.parseParams(params) : params;
    return Axios.get(path, { params: parseParam })
      .then((response: AxiosResponse) => {
        if (response.data && response.data.isSuccess)
          return Promise.resolve(response.data.data)
        return Promise.reject(response.data)
      })
      .catch(err => Promise.reject(err))
  }
  getByParsedParam<TViewModel>(path?: string, params?: any): Promise<TViewModel> {
    this._refPath = [];
    this.parseParam(params, this._refPath)
    return Axios.get(`${path}?${this._refPath.join('&')}`)
      .then((response: AxiosResponse) => {
        if (response.data && response.data.isSuccess)
          return Promise.resolve(response.data.data)
        return Promise.reject(response.data)
      })
      .catch(err => Promise.reject(err))

  }
  parseParams<TParam>(params: TParam) {
    const targetResult = {};
    Object.keys(params).forEach(key => {
      if (Array.isArray(params[key]) && params[key].length > 0) {
        targetResult[key] = params[key].join(',')
      }
      else if(!isNullOrUndefined(params[key]) && typeof params[key] === 'object')
      {
        Object.keys(params[key]).forEach(function(ObKey, ObIndex) {
          //myObject[key] *= 2;
          const newKey = `${key}[${ObKey}]`
          targetResult[newKey] = params[key][ObKey]
        });
      }
      else if (!isNullOrUndefined(params[key]) && typeof params[key] !== 'object') {
        targetResult[key] = params[key];
      }
    })
    console.log(targetResult)
    return Promise.resolve(targetResult)
  }
  post<TMetaData>(path?: string, metaData?: TMetaData, config?): Promise<any> {
    return Axios.post(path, metaData, config)
      .then((response: AxiosResponse) => {
        if (response.data && response.data.isSuccess)
          return Promise.resolve(response.data.data)
        return Promise.reject(response.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  }
  patch<TMetaData>(path?: string, metaData?: TMetaData, config?): Promise<any> {

    if (metaData['id']) delete metaData['id'];

    return Axios.patch(path, metaData, config)
      .then((response: AxiosResponse) => {
        if (response.data && response.data.isSuccess)
          return Promise.resolve(response.data.data)
        return Promise.reject(response.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  }

  delete(path?: string, params?: any) {
    return Axios.delete(path, { params })
      .then((response: AxiosResponse) => {
        if (response.data && response.data.isSuccess)
          return Promise.resolve(response.data.data)
        return Promise.reject(response.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  }
  async beforePatch<T>(originObject: T, obj: T) {
    const patched = compare(originObject, obj);

    let document = {};

    Object.keys(obj).forEach(key => {
      if (Array.isArray(obj[key]) === true) {
        document[key] = obj[key];
      }
    })
    const newDocument = patched.reduce(applyReducer, document);
    return newDocument;
  }

  remove(path?: string) {
    return Axios.delete(path)
      .then((response: AxiosResponse) => {
        if (response.data && response.data.isSuccess)
          return Promise.resolve(response.data.data)
        return Promise.reject(response.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  }
  private parseParam = async (param: any, refPaths: string[], parentKey?: string, previousParent?: string) => Object.keys(param).map(key => {
    if (typeof param[key] === 'object') {
      return this.parseParam(param[key], refPaths, key, parentKey)
    }
    else {
      if (parseInt(key) >= 0) {
        const partPath: string = `${previousParent}[${parentKey}]=${param[key]}`
        return refPaths.push(partPath)
      }
      else if (param[key]) {
        let partPath: string;
        if (parentKey) {
          partPath = `${parentKey}[${key}]=${param[key]}`;
        } else {
          partPath = `${key}=${param[key]}`;
        }
        return refPaths.push(partPath)
      }
    }
  })

}



// WEBPACK FOOTER //
// ./src/services/base.service.ts